export default __webpack_public_path__ + "static/media/wwf_medium@2x.232f80f7.jpg";